import type { HuntType, TimeBlock } from '@/shared/domain'
import type { HuntTimeBlockOption } from './hunt-time-period-selector'

export function toHuntTimeBlockOptions(
  blocks: TimeBlock[],
  huntType: HuntType | null,
): HuntTimeBlockOption[] {
  if (!huntType) return []
  return blocks
    .filter((block) => block.huntType === huntType)
    .map((block) => ({
      timePeriod: block.timePeriod,
      label: block.name,
      from: block.startTime,
      to: block.endTime,
    }))
}
